export const navItems = ['skills', 'portfolio', 'work', 'blog', 'contact'];
